export default __webpack_public_path__ + "static/identifiera-online-med-bankid-11f6dad158f2fa6283e2da89ff843619.jpg";